module.exports = __webpack_public_path__ + "img/all-application.84ac996b.svg";